import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { PermissionCatalog, Role, RolePayload } from '../types/roles';

export const rolesApi = {
	list: async (): Promise<Role[]> => apiClient.get<Role[]>(API_ENDPOINTS.SETTINGS.ROLES),

	catalog: async (): Promise<PermissionCatalog> =>
		apiClient.get<PermissionCatalog>(API_ENDPOINTS.SETTINGS.PERMISSIONS),

	create: async (payload: RolePayload): Promise<Role> =>
		apiClient.post<Role>(API_ENDPOINTS.SETTINGS.ROLES, payload),

	update: async (id: number, payload: RolePayload): Promise<Role> =>
		apiClient.put<Role>(API_ENDPOINTS.SETTINGS.ROLE_DETAIL(id), payload),

	delete: async (id: number): Promise<void> => {
		await apiClient.delete<void>(API_ENDPOINTS.SETTINGS.ROLE_DETAIL(id));
	},
};
